export const companyNamesSeeds = [
  { "id": 1, "value": "BRAC" },
  { "id": 2, "value": "Ispahani" },
  { "id": 3, "value": "Lalteer" },
  { "id": 4, "value": "National Agricare" },
  { "id": 5, "value": "SEMCO" },
  { "id": 6, "value": "Suprime" }
];

export const CompanyNamesCP =[
  { "id": 1, "value": "ACI Crop Care" },
  { "id": 2, "value": "Auto Crop Care" },
  { "id": 3, "value": "Clean Agro" },
  { "id": 4, "value": "Corbel" },
  { "id": 5, "value": "Eminence" },
  { "id": 6, "value": "Haychem" },
  { "id": 7, "value": "Intefa" },
  { "id": 8, "value": "Mc. Donald" },
  { "id": 9, "value": "Mimpex" },
  { "id": 10, "value": "National Agricare" },
  { "id": 11, "value": "Petrochem" },
  { "id": 12, "value": "SEMCO" },
  { "id": 13, "value": "Shetu Corporation" },
  { "id": 14, "value": "Syngenta" },
  { "id": 15, "value": "Tense Agro" }
];


export const FieldsTobePrepopulated = ["CP_totalsale_section1_2024", "CP_totalsale_section1_2025", "Biologic_section1_2024", "Biologic_totalsale_section1_2025",
  "PGR_totalsale_section1_2024", "PGR_totalsale_section1_2025", "AllSeed_section1_2024", "AllSeed_totalsale_section1_2025", "solubleFertilizer_section1_2024",
  "solubleFertilizer_totalsale_section1_2025", "bulkFertilizer_section1_2024", "bulkFertilizer_totalsale_section1_2025", "company_top_nametop1total", "company_top_nametop2total",
  "company_top_nametop3total", "company_top_nametop4total", "company_top_nametop5total", "bayertotal2025", "retailsalesrice_RICE1_totalsale", "retailsalesrice_RICE2_totalsale",
  "retailsalesrice_RICE3_totalsale", 'bayerricetotal2025_BayerRICE_totalsale','corn_company_total_sale1', 'corn_company_total_sale2', 'corn_company_total_sale3',
  "corn_bayer_total_sale_2025", "other_fertilizer_totalsale_section1_2025", 'other_fertilizer_section1_2024', 'other_fertilizer_2024_section1_wholesalepercentage'
]

export const MTFields = [
  "retailvolumerice_RICE1",
  "retailvolumerice_RICE2",
  "retailvolumerice_RICE3",
  "bayerricewretailvolume_BayerRICE",
  'corn_company_total_volume1',
  'corn_company_total_volume2',
  'corn_company_total_volume3',
  "corn_bayer_total_sale_mt"
]

export const FieldsWithACtualData = [
  "AllSeed_section1_2024",
  "AllSeed_totalsale_section1_2025",
  "Biologic_section1_2024",
  "Biologic_totalsale_section1_2025",
  "CP_totalsale_section1_2024",
  "CP_totalsale_section1_2025",
  "PGR_totalsale_section1_2024",
  "PGR_totalsale_section1_2025",
  "company_top_nametop1total",
  "company_top_nametop2total",
  "company_top_nametop3total",
  "company_top_nametop4total",
  "company_top_nametop5total",
  "retailsalesrice_RICE1_totalsale",
  "retailsalesrice_RICE2_totalsale",
  "retailsalesrice_RICE3_totalsale",
  "bayerricetotal2025_BayerRICE_totalsale",
  "solubleFertilizer_section1_2024",
  "solubleFertilizer_totalsale_section1_2025",
  "bulkFertilizer_section1_2024",
  "bulkFertilizer_totalsale_section1_2025",
  "calculated_totalsale_2024",
  "calculated_totalsale_2025",
  
]

export const croplist = [

  {
    "id": 2,
    "value": "Apple"
  },
  {
    "id": 3,
    "value": "Bajra/Millet"
  },
  {
    "id": 4,
    "value": "Banana"
  },
  {
    "id": 5,
    "value": "Bengal Gram"
  },
  {
    "id": 6,
    "value": "Betel Nut"
  },
  {
    "id": 7,
    "value": "Black & Green Gram"
  },
  {
    "id": 8,
    "value": "Brinjal"
  },
  {
    "id": 9,
    "value": "Cardamon"
  },
  {
    "id": 10,
    "value": "Carrot"
  },
  {
    "id": 11,
    "value": "Cashew"
  },
  {
    "id": 12,
    "value": "Castor"
  },
  {
    "id": 13,
    "value": "Chillies"
  },
  {
    "id": 14,
    "value": "Citrus"
  },
  {
    "id": 15,
    "value": "Cluster Bean"
  },
  {
    "id": 16,
    "value": "Coffee"
  },
  {
    "id": 17,
    "value": "Cole crop"
  },
  {
    "id": 18,
    "value": "Coriander"
  },
  {
    "id": 19,
    "value": "Cotton"
  },
  {
    "id": 20,
    "value": "Cucurbits"
  },
  {
    "id": 21,
    "value": "Cumin"
  },
  {
    "id": 22,
    "value": "Fennel"
  },
  {
    "id": 23,
    "value": "Field Bean"
  },
  {
    "id": 24,
    "value": "Floriculture"
  },
  {
    "id": 25,
    "value": "Ginger"
  },
  {
    "id": 26,
    "value": "Grapes"
  },
  {
    "id": 27,
    "value": "Groundnut"
  },
  {
    "id": 28,
    "value": "Jowar"
  },
  {
    "id": 29,
    "value": "Jute"
  },
  {
    "id": 30,
    "value": "Leguminous Crops"
  },
  {
    "id": 31,
    "value": "leguminous Vegetables"
  },
  {
    "id": 32,
    "value": "Maize/Corn"
  },
  {
    "id": 33,
    "value": "Mango"
  },
  {
    "id": 34,
    "value": "Mentha"
  },
  {
    "id": 35,
    "value": "Mustard"
  },
  {
    "id": 36,
    "value": "Okra"
  },
  {
    "id": 37,
    "value": "Onion"
  },
  {
    "id": 38,
    "value": "Other Crops"
  },
  {
    "id": 39,
    "value": "Other Fruits"
  },
  {
    "id": 40,
    "value": "Other Oilseeds"
  },
  {
    "id": 41,
    "value": "Other Vegetables"
  },
  {
    "id": 42,
    "value": "Paddy/Rice"
  },
  {
    "id": 43,
    "value": "Papaya"
  },
  {
    "id": 44,
    "value": "Pea"
  },
  {
    "id": 45,
    "value": "Peppermint"
  },
  {
    "id": 46,
    "value": "Pineapple"
  },
  {
    "id": 47,
    "value": "Pomegranate"
  },
  {
    "id": 48,
    "value": "Potato"
  },
  {
    "id": 49,
    "value": "Red Gram"
  },
  {
    "id": 50,
    "value": "Sesamum"
  },
  {
    "id": 51,
    "value": "Sorghum"
  },
  {
    "id": 52,
    "value": "Soybean"
  },
  {
    "id": 53,
    "value": "Sugarcane"
  },
  {
    "id": 54,
    "value": "Tea"
  },
  {
    "id": 55,
    "value": "Tobacco"
  },
  {
    "id": 56,
    "value": "Tomato"
  },
  {
    "id": 57,
    "value": "Turmeric"
  },
  {
    "id": 58,
    "value": "Watermelon/Musk melon"
  },
  {
    "id": 59,
    "value": "Wheat"
  }
]